import { render, staticRenderFns } from "./RecordsListener.vue?vue&type=template&id=d594f11c&"
import script from "./RecordsListener.vue?vue&type=script&lang=js&"
export * from "./RecordsListener.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports